/* globals fetch */
import Cliser from "cliser";
import Config from "config";
import LCPClient from "lcp-client-communication";

export default class DeviceModel extends Cliser.Model {
  properties() {
    return {
      device: null, // Device ID
      serverConnected: false, // Connected to server
      connected: false, // Connected to device
      status: null, // null, "connecting", "connected", "requestingStream", "streaming"
      error: null, // Error object
      photo: {}, // Device photo: null or {options: camera options, src: source url, image: Image}
      values: {}, // variables: {digits, pointer, impulse, sendData}
      version: null, // Device software version,
      multipleClients: false, // Multiple client connections to device open
      deviceHw:null,
    };
  }

  init() {
    console.log("DeviceModel.init");
    this.callbacks = {
      onConnect: this.onDeviceConnect.bind(this),
      onDisconnect: this.onDeviceDisconnect.bind(this),
      onServerConnect: this.onServerConnect.bind(this),
      onServerAuthError: this.onServerAuthError.bind(this),
      onMultipleClients: this.onMultipleClients.bind(this),
      //      onDeviceTrace: this.onDeviceTrace.bind(this)
    };
    LCPClient.on("device-connected", this.callbacks.onConnect);
    LCPClient.on("device-disconnected", this.callbacks.onDisconnect);
    LCPClient.on("authenticated", this.callbacks.onServerConnect);
    LCPClient.on("authentication-error", this.callbacks.onServerAuthError);
    LCPClient.on("multiple-clients", this.callbacks.onMultipleClients);
    //    LCPClient.on('trace', this.callbacks.onDeviceTrace);
  }

  uninit() {
    LCPClient.removeListener("device-connected", this.callbacks.onConnect);
    LCPClient.removeListener(
      "device-disconnected",
      this.callbacks.onDisconnect
    );
    LCPClient.removeListener("authenticated", this.callbacks.onServerConnect);
    LCPClient.removeListener(
      "authentication-error",
      this.callbacks.onServerAuthError
    );
    //    LCPClient.removeListener('trace', this.callbacks.onDeviceTrace);
  }

  onServerConnect() {
    this.status = "connected";
    this.serverConnected = true;
    this.emit();
  }

  onServerAuthError(error) {
    throw error;
  }
  /*
    onDeviceTrace(deviceId, message) {
     console.log("trace from:" + deviceId + " message: " + JSON.stringify(message));
    }
  */
  onDeviceConnect(deviceId) {
    console.log("DeviceModel.onDeviceConnect", deviceId);

    this.status = "connected";
    this.connected = true;

    const subscribe = (id, apiKey, stateKey) => {
      LCPClient.subscribeTo(id, apiKey, (err, resp) => {
        if (!err && resp) {
          this.values[stateKey] = resp.value;
          this.emit();
        }
      });
      LCPClient.on(apiKey, (from, msg) => {
        this.values[stateKey] = msg.value;
        this.emit();
      });
    };

    const getVersion = (id) => {
      LCPClient.sendTo(id, "version-info", null, (err, resp) => {
        if (!err && resp.appVersion !== "version_not_available") {
          this.version = resp;
        }
      });
    };
    const getImageVersion = (id) => {
      LCPClient.sendTo(id, "get-image-version", null, (err, resp) => {
        console.log("Image Version:", resp);
      });
    };

    const getHwVersion = (id) => {
      LCPClient.sendTo(id, "get-hw-version", null, (err, resp) => {
        console.log("HW Version:", resp);
        this.deviceHw = resp;
        this.emit();
      });
    };

    subscribe(this.device, "digitsIntegerValue", "digitInteger");
    subscribe(this.device, "digitsDecimalValue", "digitDecimal");
    subscribe(this.device, "pointerValue", "pointer");
    subscribe(this.device, "impulseValue", "impulse");
    subscribe(this.device, "sendData", "sendData");
    getVersion(this.device);
    getImageVersion(this.device);
    getHwVersion(this.device);
    /*
        LCPClient.requestTo(deviceId, "deactivate-trace", {identifiers:['device:image-analyzer', 'device:variable', 'device:data-aggregator', 'device:info']}, function(err, resp) {
          console.log(deviceId + ": response to deactivate-trace:", resp);
        });
    
    
        LCPClient.subscribeTo(deviceId, 'trace', (err, resp) => {
          console.log(resp);
        });
    
        LCPClient.requestTo(deviceId, "activate-trace", {identifiers:['device:image-analyzer', 'device:data-aggregator', 'device:value-history']}, function(err, resp) {
          console.log(deviceId + ": response to activate-trace:", resp);
        });
    */
    this.emit();
  }

  onMultipleClients(args) {
    //console.log("onMultipleClients", args);
    this.multipleClients = true;
    this.emit();
  }

  onDeviceDisconnect(deviceId) {
    console.log("DeviceModel.onDeviceDisconnect", deviceId);
    if (this.device && this.device === deviceId) {
      this.status = null;
      this.connected = false;
      this.emit();
    }
  }

  static connectServer() {
    this.error = null;
    this.status = "connecting";

    // Get auth
    return new Promise((resolve, reject) => {
      return (
        Cliser.LoginModel.getState()

          // Connect device
          .then((login) => {
            if (!login.token) {
              reject(new Error("not authenticated"));
            }
            LCPClient.disconnect();
            LCPClient.connect({
              devices: 0,
              url: Config.servers.api,
              token: login.token,
              system: true,
              autoJoin: false,
            })
              .then(() => {
                resolve(() => {
                  this.emit();
                });
              })

              // Handle error
              .catch((error) => {
                this.status = null;
                this.error = error;
                this.serverConnected = false;
                reject(error);
              });
          })
      );
    });
  }

  static connectDevice(device, server) {
    //console.log('Connect device', device, this);
    if (!this.serverConnected) {
      throw new Error("Not connected to server");
    }
    if (this.device && this.device !== device) {
      LCPClient.leaveDevice(this.device);
      this.device = null;
      this.version = null;
      this.multipleClients = false;
    }
    if (!this.device) {
      LCPClient.joinDevice(device, server);
      this.device = device;
    }
  }

  static takeCustomPhoto(options, orientation) {
    this.status = "requestingStream";

    return new Promise((resolve, reject) => {
      LCPClient.streamRequestTo(
        this.device,
        "custom-photo",
        { camera: options, orientation },
        (err, response, stream) => {
          if (err) {
            reject(err);
          } else {
            var arr = [];

            this.status = "streaming";
            stream.on("data", (chunk) => {
              arr.push(chunk);
            });

            stream.on("end", () => {
              var blob = new Blob(arr, {
                type: "image/jpeg",
              });

              this.photo = {
                imageData: new File(arr, "sendimage.jpg"),
                options,
                src: window.URL.createObjectURL(blob),
              };
              this.status = "connected";
              resolve(this.photo);
            });
          }
        }
      );
    });
  }

  static setMeterValue(integers, decimals) {
    return new Promise((resolve, reject) => {
      let value = {};
      if (integers !== "" && !isNaN(parseInt(integers))) {
        value.integers = parseInt(integers);
      }
      if (decimals !== "" && !isNaN(parseInt(decimals))) {
        value.decimals = decimals;
      }
      LCPClient.sendTo(this.device, "set-meter-value", value, (err, resp) => {
        if (err) {
          reject(err);
        } else {
          LCPClient.sendTo(
            this.device,
            "start-analyze-cycle",
            {},
            (err, resp) => {
              if (err) {
                reject(err);
              } else {
                resolve(resp);
              }
            }
          );
        }
      });
    });
  }

  static setDataSend(enabled) {
    this.values.sendData = enabled ? 1 : 0;
  }

  static rebootDevice() {
    return new Promise((resolve, reject) => {
      LCPClient.sendTo(this.device, "reboot", {}, (err, resp) => {
        if (err) {
          return reject(err);
        }
        return resolve();
      });
    });
  }

  static restartDeviceSw() {
    return new Promise((resolve, reject) => {
      LCPClient.sendTo(this.device, "restart-device-sw", {}, (err, resp) => {
        if (err) {
          return reject(err);
        }
        return resolve();
      });
    });
  }
  static sendCustomCmd(command, params) {
    return new Promise((resolve, reject) => {
      LCPClient.sendTo(this.device, command, params, (err, resp) => {
        if (err) {
          return reject(err);
        }
        return resolve(resp);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./client/models/DeviceModel.js